<template>
  <div class="recordList">
    <van-tabs v-model="active"  color="#2675ea" @click="getList(active)" type="card" >
      <van-tab :title="item.title" v-for="(item,index) in list" :key="index">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
        <div v-for="(item,index) in recordList" :key="index" class="rechargeRecordItem">
          <div v-show="active == 0">
            <div >订单号</div>
            <div>{{item.order_no}}</div>
          </div>
          <div v-show="active == 1">
            <div>订单号</div>
            <div>{{item.child_order_no}}</div>
          </div>
          <div>
            <div>购买年包的手机号码</div>
            <div>{{item.recharge_account}}</div>
          </div>
          <div v-show="active == 0">
            <div>购买时间</div>
            <div>{{ new Date(parseInt(item.recharge_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ').split(' ')[0] }}</div>
          </div>
          <div v-show="active == 1">
            <div>兑换时间</div>
            <div>{{ new Date(parseInt(item.use_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ').split(' ')[0] }}</div>
          </div>
          <div>
            <div>订单过期时间</div>
            <div>{{ new Date(parseInt(item.expire_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ').split(' ')[0] }}</div>
          </div>
        
        </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { List, PullRefresh, Cell, Tab, Tabs  } from 'vant'
import Param from '../../assets/js/Param.js'
export default {
  name: 'recordList',
  components: {
    vanList : List,
    vanPullRefresh: PullRefresh,
    vanCell: Cell,
    vanTab: Tab,
    vanTabs: Tabs,
  },
  data() {
    return {
      active: 0,
      list: [{title:'购买记录'},{title:'兑换记录'},],
      recordList: [],
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  created() {
    console.log(this.active)
  },
  methods: {
    async getList(active) {
      this.finished = false
      this.loading = true
      this.recordList = []
      if (active == 0) {
        this.onLoad()
        return
      }
      if (active == 1) {
        let exList = await this.exchageList()
        this.recordList = exList.data.list
        this.finished = true
        this.loading = false
        return
      }
    },
    async onLoad() {
      let payList = await this.payList()
      this.recordList = payList.data.list
      this.finished = true
      this.loading = false
    },
    payList() {
      return new Promise(resolve => {
        this.$http.get('/test/v1/yk-vip-annual-package/pay-history?' + Param.init({
          page: 1,
          page_size: 999
        }).re()).then((res) => {
          resolve(res.data)
        })
      })
    },
    exchageList() {
      return new Promise(resolve => {
        this.$http.get('/test/v1/yk-vip-annual-package/exchange-history?' + Param.init({
          page: 1,
          page_size: 999
        }).re()).then((res) => {
          resolve(res.data)
        })
      })
    }
  },
}
</script>

<style lang='less' scope>
  .recordList {
    padding: .2rem 0;

      .rechargeRecordItem {
        height: 3.5rem;
        background: #fff;
        margin-top: 0.46rem;
        padding: 0 0.18rem;
        font-size: 0.28rem;
        font-family: SourceHanSansSC-Normal;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 0.9rem;
        > div:last-child {
          border: none;
        }
        > div {
          border-bottom: 0.01rem solid #dcdcdc;
          display: flex;
          justify-content: space-between;
          padding: 0 0.4rem 0 0.2rem;
          > div:nth-child(1) {
            text-align: left;
          }
          > div:nth-child(2) {
            text-align: right;
          }
          > div {
            flex: 1;
          }
        }
      }

      .moneyStyle {
        color: #f8761f;
      }
    
  }

</style>


// WEBPACK FOOTER //
// src/components/youKu/recordList.vue